"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Title = exports.Root = exports.Inner = void 0;
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        padding: theme.spacing(0, 3, 6, 3),
        overflow: 'hidden',
        background: theme.palette.common.white,
        [theme.breakpoints.up(768)]: {
            borderRadius: theme.spacing(1)
        }
    };
});
const Inner = exports.Inner = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        maxWidth: 614,
        margin: theme.spacing(0, 'auto')
    };
});
const Title = exports.Title = (0, _mui.styled)('h1')((param)=>{
    let { theme } = param;
    return {
        margin: 0,
        padding: theme.spacing(6, 0, 4, 0),
        color: theme.palette.text.secondary,
        fontSize: '2.5rem',
        fontWeight: theme.typography.fontWeightBold,
        lineHeight: 1.25,
        textAlign: 'center'
    };
});
